/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({
  description,
  lang,
  meta,
  title,
  image,
  author,
  date,
  article,
  keywords,
  robots,
  revisit_after,
  url,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const [documentIsReady, setDocumentIsReady] = useState(false)

  useEffect(
    () => setDocumentIsReady(document.querySelector("header") != null),
    []
  )

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: keywords,
        },
        {
          name: `robots`,
          content: robots,
        },
        {
          name: `revisit-after`,
          content: revisit_after,
        },
        {
          name: `author`,
          content: author ? author : site.siteMetadata.author,
        },
        {
          property: `article:published_time`,
          content: date && date,
        },
        {
          property: `og:title`,
          content: title
            ? title
            : "Mission Labs - Powering the future of digital customer experiences",
        },
        {
          property: `og:url`,
          content: url ? url : "https://www.missionlabs.co.uk",
        },
        {
          property: `og:image:url`,
          name: `image`,
          content: image
            ? "https:" + image
            : "https://circleloop-assets.s3-eu-west-1.amazonaws.com/Mission+Labs/ML-F-Banner.png",
        },
        {
          property: `og:image`,
          content: image
            ? "https:" + image
            : "https://circleloop-assets.s3-eu-west-1.amazonaws.com/Mission+Labs/ML-F-Banner.png",
        },
        {
          property: `og:description`,
          content: metaDescription
            ? metaDescription
            : "We power the future of digital customer experience transformation through cutting-edge communication technology.",
        },
        {
          property: `og:type`,
          content: article ? `article` : `website`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:creator`,
          content: author ? author : site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title
            ? title
            : "We power the future of digital customer experience transformation through cutting-edge communication technology.",
        },
        {
          name: `twitter:description`,
          content: metaDescription
            ? metaDescription
            : "We specialise in the development and delivery of next-generation digital customer experience solutions.",
        },
        {
          name: `twitter:url`,
          content: url ? url : "https://www.missionlabs.co.uk",
        },
        {
          name: `twitter:image`,
          content: image
            ? "https:" + image
            : "https://circleloop-assets.s3-eu-west-1.amazonaws.com/Mission+Labs/ML-T-Banner.png",
        },
      ].concat(meta)}
    >
      <script type="application/ld+json">
        {`
        { 
          "@context" : "http://schema.org",
          "@type" : "Organization",
          "name" : "Mission Labs",
          "url" : "https://www.missionlabs.co.uk/",
          "Logo" : "https://circleloop-assets.s3-eu-west-1.amazonaws.com/Mission+Labs/ML+Logo+Black+Strap.svg",
          "sameAs" : [
              "https://www.linkedin.com/company/missionlabs", "https://www.twitter.com/missionlabshq",
              ]
          }
      `}
      </script>

      {documentIsReady && (
        <script>
          {(function (h, o, t, j, a, r) {
            h.hj =
              h.hj ||
              function () {
                ;(h.hj.q = h.hj.q || []).push(arguments)
              }
            h._hjSettings = { hjid: 2254735, hjsv: 6 }
            a = o.getElementsByTagName("head")[0]
            r = o.createElement("script")
            r.async = 1
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
            a.appendChild(r)
          })(
            window,
            document,
            "https://static.hotjar.com/c/hotjar-",
            ".js?sv="
          )}
        </script>
      )}

      {url && <link rel="canonical" href={url} />}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
